"use client";

import React from "react";
import { Plus, Minus, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "How do you select the top AI tools for 2026?",
  answer: "Our selection process is rigorous and data-driven. We test each tool for performance, automation capabilities, and ease of integration. Only software that meets our high standards for reliability and innovation—such as Jasper and Pictory—makes it to our curated lists."
}, {
  question: "Are the reviews on AIAffiliate unbiased?",
  answer: "Absolutely. While we may earn commissions through affiliate links, our reviews are grounded in expert analysis and actual testing. We prioritize transparency and objective insights to help you make the best decisions for your business."
}, {
  question: "Do the recommended tools offer free trials?",
  answer: "Yes, the majority of the tools we feature, including Copy.ai and other top contenders, offer free trials. We provide clear 'Try for Free' buttons throughout our reviews to ensure you can test the software risk-free before committing."
}, {
  question: "Who is this platform designed for?",
  answer: "AIAffiliate is built for tech-savvy professionals, entrepreneurs, and product managers seeking advanced automation solutions. Our content is concise and technical, designed to provide high-value insights without the fluff."
}];
export default function SelectionFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="selection-faq" className="dark bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div ref={ref} className={cn("max-w-[800px] mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-4">
            Selection Protocol
          </h2>
          <p className="text-muted-foreground text-lg">
            Common questions about our analysis and review methodology.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/40 last:border-0" data-index={i}>
              <AccordionTrigger className="py-6 hover:no-underline group [&>svg:last-child]:hidden">
                <span className="text-base md:text-lg font-medium text-left pr-4">
                  {item.question}
                </span>
                <div className="relative flex items-center justify-center size-5 shrink-0 text-primary/80 transition-colors group-hover:text-primary">
                  <Plus className="absolute size-5 transition-transform duration-300 rotate-0 scale-100 group-data-[state=open]:rotate-90 group-data-[state=open]:scale-0" />
                  <Minus className="absolute size-5 transition-transform duration-300 rotate-90 scale-0 group-data-[state=open]:rotate-0 group-data-[state=open]:scale-100" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 pt-8 border-t border-border/40 flex justify-center">
          <Link to="/ContactPage" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-medium group">
            Still confused? Contact the Lab
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}